'use strict'

var $ = window.jQuery;

function init() {
	if ($('#donateFunds').length === 0) {
		return;
	}

	var givenValues = [];
	$('.donate__value').each(function() {
		givenValues.push( parseFloat($(this).text().replace(/,/g, '').trim().substring(1)) );
	});

	valueSelector(givenValues);
	matchButtonToInput(givenValues);

    window.addEventListener('message', function(event) {
        if (event.data.status === 'success') {
            const button = document.querySelector(".formDonationSubmitButton");
            if (button) {
                button.click();
            }
        }
    });
}

function valueSelector(givenValues) {
	$(document).on('click', '.donate__value', function(event) {
		var value = $(this).text().trim().slice(1).replace(/,/g, '');
		valueImageSelect(this, value);
	});

	var doMatchButtonToInput = function() { //Avoids re-wrapping the function every time we call it with a timeout
		matchButtonToInput(givenValues);
	};

	var donateAmountTimeoutId = 0; //Timeout logic from http://stackoverflow.com/a/5913348
	$(document).on('input', '.donate__amount input', function(event) {
	    clearTimeout(donateAmountTimeoutId); //doesn't matter if it's 0
	    donateAmountTimeoutId = setTimeout(doMatchButtonToInput, 300);
	});

	$(document).on('change', '.donate__amount input', function(event) {
		clearTimeout(donateAmountTimeoutId); //doesn't matter if it's 0
		doMatchButtonToInput();
	});
	document.addEventListener('jsfAjaxEvent', function() {
		clearTimeout(donateAmountTimeoutId); //doesn't matter if it's 0
		doMatchButtonToInput();
	});
}

/**
 * Checks given number against an array of numbers and returns closest less than given.
 * @param  {number} number The number specified
 * @param  {array} array  Passed aray of numbers
 * @return {object} current An object containing the closest index and value
 */
function getClosestUnder(number, array) {
	// Sets baseline
	var closestValue = array[0];
	var closestIndex = 0;

	array.forEach(function(value, index) {
		// Sets closest to next in value in array if number less than
		// and not at end of array.
		if ((number < closestValue) && (index < (array.length))) {
			closestIndex = index;
			closestValue = array[index++];
		}
	});

	return {'index': closestIndex, 'value': closestValue};
}

/**
 * Sets as active the appropriate button and image.
 * @param  {object} selected The dom element to be used
 * @param  {number} value    [description]
 */
function valueImageSelect(selected, value) {
	var index = $(selected).attr('item');

	$('.donate__value--active').removeClass('donate__value--active');
	$(selected).addClass('donate__value--active');
	$('.donate__images #donate-value-' + index).addClass('donate__value--active');

	if (value) {
		$('.donate__amount input').val(reformatCurrencyNumber(value));
	}

	return;
}

function reformatCurrencyNumber(value) {
	if (typeof(value) !== 'number')
		value = parseFloat(value.toString().replace(/,/g, '').trim());
	return value.toLocaleString();
}

function matchButtonToInput(givenValues) {
	var $donateInputVal = $('.donate__amount input').val();
	if ($donateInputVal) {
		var inputValue = parseFloat($donateInputVal.replace(/,/g, ''));
		var current = getClosestUnder(inputValue, givenValues);
		var selectedButton = $('.donate__value').get(current['index']);
		valueImageSelect(selectedButton);
	}
}

var DonateFunds = {
	init: init
};

module.exports = DonateFunds;
